import {combineReducers} from 'redux';
import app from './app';
import aqfx from './aqfx';
import aws from './aws';
import boundaries from './boundaries';
import fms from './fms';
import graphs from './graphs';
import incidents from './incidents';
import indicator_overlays from './indicator_overlays';
import indicators from './indicators';
import keycloak from './keycloak';
import manual_weather from './manual_weather';
import map from './map';
import messages from './messages';
import overlays from './overlays';
import play from './play';
import point from './point';
import point_data_grass from './point_data_grass';
import point_data_leaflet_80 from './point_data_leaflet_80';
import point_data_mallee_heath from './point_data_mallee_heath';
import point_data_mcarthur_mk5 from './point_data_mcarthur_mk5';
import point_data_prescriptions from './point_data_prescriptions';
import point_data_vesta from './point_data_vesta';
import {createVestaMk2Reducer} from './point_data_vesta_mk2';
import {DATA_SETS} from '../Constants';
import {DEFAULT_VARIABLES_DRY, DEFAULT_VARIABLES_WET} from '../utils/behaviour_models/vesta_mk2/constants';
import point_data_weather from './point_data_weather';
import popup_data from './popup_data';
import routing from './routing';
import time from './time';
import timeline from './timeline';
import timeline_dnd from './timeline_dnd';
import view from './view';
import wind_data from './wind_data';

const reducers = combineReducers({
  app,
  aws,
  fms,
  aqfx,
  manual_weather,
  map,
  routing,
  boundaries,
  graphs,
  point_data_weather,
  point_data_mcarthur_mk5,
  point_data_vesta,
  point_data_vesta_mk2_dry: createVestaMk2Reducer(DATA_SETS.VESTA_MK2_DRY, DEFAULT_VARIABLES_DRY),
  point_data_vesta_mk2_wet: createVestaMk2Reducer(DATA_SETS.VESTA_MK2_WET, DEFAULT_VARIABLES_WET),
  point_data_leaflet_80,
  point_data_grass,
  point_data_mallee_heath,
  point_data_prescriptions,
  point,
  indicators,
  overlays,
  popup_data,
  wind_data,
  time,
  play,
  view,
  messages,
  indicator_overlays,
  timeline_dnd,
  timeline,
  incidents,
  keycloak
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js